// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.feature-card {
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.03) -30.29%, rgba(255, 255, 255, 0) 144.92%);
  backdrop-filter: blur(25px);
  /* Note: backdrop-filter has minimal browser support */
  border-radius: 15px;
  padding: 34px 30px;
  text-align: center;
  border: 1px solid #F5FBF2;
  margin-bottom: 2rem;
  margin-top: 2rem;
  max-width: 318px;
}
@media screen and (min-width: 834px) {
  .feature-card {
    margin-right: 2rem;
    margin-left: 2rem;
    margin-bottom: 3rem;
    margin-top: 3rem;
  }
}
.feature-card img {
  margin-bottom: 1.5rem;
}
.feature-card .title {
  font-family: "Fontspring demo nekst", sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  margin-bottom: 1.5rem;
}
@media screen and (min-width: 1440px) {
  .feature-card .title {
    font-size: 20px;
  }
}
.feature-card .content {
  font-family: Inter, sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
}
@media screen and (min-width: 1440px) {
  .feature-card .content {
    font-size: 16px;
  }
}

.feature-card-container {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: center;
}
@media screen and (min-width: 834px) {
  .feature-card-container {
    flex-direction: row;
  }
}

.roadmap .mobile {
  margin-top: 1rem;
}
@media screen and (min-width: 834px) {
  .roadmap .mobile {
    display: none;
  }
}
.roadmap .tab {
  display: none;
  margin-top: 2rem;
}
@media screen and (min-width: 834px) {
  .roadmap .tab {
    display: block;
  }
}
@media screen and (min-width: 1440px) {
  .roadmap .tab {
    display: none;
  }
}
.roadmap .desktop {
  display: none;
}
@media screen and (min-width: 1440px) {
  .roadmap .desktop {
    display: block;
    margin-top: 2rem;
  }
}

.pillar-card {
  margin-top: 3rem;
  text-align: center;
  background: linear-gradient(165.98deg, rgba(200, 255, 232, 0.12) -3.13%, rgba(217, 217, 217, 0) 93.55%);
  border-radius: 38px;
  border: 4px solid #113E4B;
  padding: 34px 30px;
  position: relative;
}
@media screen and (min-width: 834px) {
  .pillar-card {
    max-width: 30%;
  }
}
.pillar-card img {
  width: 56px;
  position: absolute;
  left: calc(50% - 28px);
  top: -28px;
}
@media screen and (min-width: 1440px) {
  .pillar-card img {
    width: 104px;
    left: calc(50% - 52px);
    top: -52px;
  }
}
.pillar-card .title {
  font-family: "Fontspring demo nekst", sans-serif;
  font-weight: 700;
  font-size: 16px;
  margin-bottom: 1rem;
}
@media screen and (min-width: 1440px) {
  .pillar-card .title {
    font-size: 24px;
    margin-top: 2rem;
  }
}
.pillar-card .content {
  font-family: Inter, sans-serif;
  font-weight: 400;
  font-size: 14px;
}
@media screen and (min-width: 1440px) {
  .pillar-card .content {
    font-size: 16px;
  }
}

.pillar-container {
  margin-right: auto;
  margin-left: auto;
  max-width: 1200px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
@media screen and (min-width: 834px) {
  .pillar-container {
    justify-content: space-between;
    flex-direction: row;
  }
}

.team-card {
  padding: 18px;
  background: rgba(255, 255, 255, 0.04);
  backdrop-filter: blur(2px);
  margin: 5px;
  /* Note: backdrop-filter has minimal browser support */
  border: 1px solid #E2FFF0;
  border-radius: 17px;
  text-align: center;
}
@media screen and (min-width: 834px) {
  .team-card {
    padding: 40px;
    margin: 10px;
  }
}
.team-card img {
  max-width: 114px;
  border-radius: 10px;
}
@media screen and (min-width: 834px) {
  .team-card img {
    max-width: 218px;
  }
}
.team-card .title {
  font-weight: 500;
  font-size: 16px;
  font-family: "Fontspring demo nekst", sans-serif;
  margin-top: 1rem;
  margin-bottom: 1rem;
}
@media screen and (min-width: 834px) {
  .team-card .title {
    font-size: 20px;
  }
}
.team-card .description {
  opacity: 0.5;
  font-family: Inter, sans-serif;
  font-weight: 500;
  font-size: 12px;
}
@media screen and (min-width: 834px) {
  .team-card .description {
    font-size: 20px;
  }
}

.team-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

@media screen and (min-width: 834px) {
  .section-15 {
    margin: auto;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/home.scss"],"names":[],"mappings":"AAAA;EACE,sGAAA;EACA,2BAAA;EACA,sDAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;AACF;AAAE;EAXF;IAYI,kBAAA;IACA,iBAAA;IACA,mBAAA;IACA,gBAAA;EAGF;AACF;AAFE;EACE,qBAAA;AAIJ;AAFE;EACE,gDAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EAIA,qBAAA;AACJ;AAJI;EALF;IAMI,eAAA;EAOJ;AACF;AAJE;EACE,8BAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AAMJ;AAJI;EANF;IAOI,eAAA;EAOJ;AACF;;AAJA;EACE,aAAA;EACA,eAAA;EACA,sBAAA;EACA,uBAAA;AAOF;AANE;EALF;IAMI,mBAAA;EASF;AACF;;AANE;EAIE,gBAAA;AAMJ;AATI;EADF;IAEI,aAAA;EAYJ;AACF;AATE;EACE,aAAA;EACA,gBAAA;AAWJ;AAVI;EAHF;IAII,cAAA;EAaJ;AACF;AAZI;EANF;IAOI,aAAA;EAeJ;AACF;AAZE;EACE,aAAA;AAcJ;AAbI;EAFF;IAGI,cAAA;IACA,gBAAA;EAgBJ;AACF;;AAbA;EACE,gBAAA;EACA,kBAAA;EACA,uGAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;AAgBF;AAfE;EARF;IASI,cAAA;EAkBF;AACF;AAjBE;EACE,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,UAAA;AAmBJ;AAlBI;EALF;IAMI,YAAA;IACA,sBAAA;IACA,UAAA;EAqBJ;AACF;AAnBE;EACE,gDAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;AAqBJ;AApBI;EALF;IAMI,eAAA;IACA,gBAAA;EAuBJ;AACF;AArBE;EACE,8BAAA;EACA,gBAAA;EACA,eAAA;AAuBJ;AAtBI;EAJF;IAKI,eAAA;EAyBJ;AACF;;AAtBA;EACE,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AAyBF;AAxBE;EAPF;IAQI,8BAAA;IACA,mBAAA;EA2BF;AACF;;AAxBA;EACE,aAAA;EACA,qCAAA;EACA,0BAAA;EACA,WAAA;EACA,sDAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;AA2BF;AA1BE;EATF;IAUI,aAAA;IACA,YAAA;EA6BF;AACF;AA5BE;EACE,gBAAA;EACA,mBAAA;AA8BJ;AA7BI;EAHF;IAII,gBAAA;EAgCJ;AACF;AA9BE;EACE,gBAAA;EACA,eAAA;EACA,gDAAA;EAIA,gBAAA;EACA,mBAAA;AA6BJ;AAjCI;EAJF;IAKI,eAAA;EAoCJ;AACF;AAhCE;EACE,YAAA;EACA,8BAAA;EACA,gBAAA;EACA,eAAA;AAkCJ;AAjCI;EALF;IAMI,eAAA;EAoCJ;AACF;;AAjCA;EACE,aAAA;EACA,eAAA;EACA,uBAAA;AAoCF;;AAjCE;EADF;IAEI,YAAA;EAqCF;AACF","sourcesContent":[".feature-card{\r\n  background: linear-gradient(180deg, rgba(255, 255, 255, 0.03) -30.29%, rgba(255, 255, 255, 0) 144.92%);\r\n  backdrop-filter: blur(25px);\r\n  /* Note: backdrop-filter has minimal browser support */\r\n  border-radius: 15px;\r\n  padding: 34px 30px;\r\n  text-align: center;\r\n  border: 1px solid #F5FBF2;\r\n  margin-bottom: 2rem;\r\n  margin-top: 2rem;\r\n  max-width: 318px;\r\n  @media screen and (min-width: 834px){\r\n    margin-right: 2rem;\r\n    margin-left: 2rem;\r\n    margin-bottom: 3rem;\r\n    margin-top: 3rem;\r\n  }\r\n  img{\r\n    margin-bottom: 1.5rem;\r\n  }\r\n  .title{\r\n    font-family: 'Fontspring demo nekst', sans-serif;\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    font-size: 16px;\r\n    @media screen and (min-width: 1440px){\r\n      font-size: 20px;\r\n    }\r\n    margin-bottom: 1.5rem;\r\n  }\r\n  .content{\r\n    font-family: Inter, sans-serif;\r\n    font-style: normal;\r\n    font-weight: 400;\r\n    font-size: 14px;\r\n    \r\n    @media screen and (min-width: 1440px){\r\n      font-size: 16px;\r\n    }\r\n  }\r\n}\r\n.feature-card-container{\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  @media screen and (min-width: 834px){\r\n    flex-direction: row;\r\n  }\r\n}\r\n.roadmap{\r\n  .mobile{\r\n    @media screen and (min-width: 834px){\r\n      display:none;\r\n    }\r\n    margin-top:1rem;\r\n  }\r\n  .tab{\r\n    display:none;\r\n    margin-top:2rem;\r\n    @media screen and (min-width: 834px){\r\n      display:block;\r\n    }\r\n    @media screen and (min-width: 1440px){\r\n      display:none;\r\n    }\r\n  }\r\n\r\n  .desktop{\r\n    display:none;\r\n    @media screen and (min-width: 1440px){\r\n      display:block;\r\n      margin-top: 2rem;\r\n    }\r\n  }\r\n}\r\n.pillar-card{\r\n  margin-top: 3rem;\r\n  text-align: center;\r\n  background: linear-gradient(165.98deg, rgba(200, 255, 232, 0.12) -3.13%, rgba(217, 217, 217, 0) 93.55%);\r\n  border-radius: 38px;\r\n  border: 4px solid #113E4B;\r\n  padding: 34px 30px;\r\n  position: relative;\r\n  @media screen and (min-width: 834px){\r\n    max-width: 30%;\r\n  }\r\n  img{\r\n    width: 56px;\r\n    position: absolute;\r\n    left: calc(50% - 28px);\r\n    top: -28px;\r\n    @media screen and (min-width: 1440px){\r\n      width: 104px;\r\n      left: calc(50% - 52px);\r\n      top: -52px;\r\n    }\r\n  }\r\n  .title{\r\n    font-family: 'Fontspring demo nekst', sans-serif;\r\n    font-weight: 700;\r\n    font-size: 16px;\r\n    margin-bottom: 1rem;\r\n    @media screen and (min-width: 1440px){\r\n      font-size: 24px;\r\n      margin-top:2rem;\r\n    }\r\n  }\r\n  .content{\r\n    font-family: Inter, sans-serif;\r\n    font-weight: 400;\r\n    font-size: 14px;\r\n    @media screen and (min-width: 1440px){\r\n      font-size: 16px;\r\n    }\r\n  }\r\n}\r\n.pillar-container{\r\n  margin-right: auto;\r\n  margin-left: auto;\r\n  max-width: 1200px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  @media screen and (min-width: 834px){\r\n    justify-content: space-between;\r\n    flex-direction: row;\r\n  }\r\n\r\n}\r\n.team-card{\r\n  padding: 18px;\r\n  background: rgba(255, 255, 255, 0.04);\r\n  backdrop-filter: blur(2px);\r\n  margin:5px;\r\n  /* Note: backdrop-filter has minimal browser support */\r\n  border: 1px solid #E2FFF0;\r\n  border-radius: 17px;\r\n  text-align: center;\r\n  @media screen and (min-width: 834px){\r\n    padding: 40px;\r\n    margin:10px;\r\n  }\r\n  img{\r\n    max-width: 114px;\r\n    border-radius: 10px;\r\n    @media screen and (min-width: 834px){\r\n      max-width: 218px;\r\n    }\r\n  }\r\n  .title{\r\n    font-weight: 500;\r\n    font-size: 16px;\r\n    font-family: 'Fontspring demo nekst', sans-serif;\r\n    @media screen and (min-width: 834px){\r\n      font-size: 20px;\r\n    }\r\n    margin-top: 1rem;\r\n    margin-bottom: 1rem;\r\n  }\r\n  .description{\r\n    opacity: 0.5;\r\n    font-family: Inter, sans-serif;\r\n    font-weight: 500;\r\n    font-size: 12px;\r\n    @media screen and (min-width: 834px){\r\n      font-size: 20px;\r\n    }\r\n  }\r\n}\r\n.team-container{\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  justify-content: center;\r\n}\r\n.section-15{\r\n  @media screen and (min-width: 834px){\r\n    margin: auto;\r\n  }\r\n  @media screen and (min-width: 1440px){\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
